import {View} from 'react-native'
import {useReducedMotion} from 'react-native-reanimated'
import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import {ChevronTop_Stroke2_Corner0_Rounded as ChevronUp} from '#/components/icons/Chevron'
import swipeUpForMoreData from '../../../../assets/capsule/lottie/swipe-up-for-more.json'

/**
 * Web renderer for the "Swipe up for more" hand animation (Lottie).
 *
 * Uses @lottiefiles/dotlottie-react with the raw JSON passed via `data` so no
 * extra static asset URL handling is needed. Honours prefers-reduced-motion by
 * swapping the looping animation for a static swipe-up glyph.
 */
export function SwipeUpLottie({size = 52}: {size?: number}) {
  const reducedMotion = useReducedMotion()

  if (reducedMotion) {
    return (
      <View
        style={{
          width: size,
          height: size,
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <View
          style={{
            width: size * 0.6,
            height: size * 0.6,
            borderRadius: size * 0.3,
            backgroundColor: 'rgba(255, 255, 255, 0.14)',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <ChevronUp
            width={size * 0.3}
            height={size * 0.3}
            style={{marginBottom: -size * 0.06}}
            fill="white"
          />
        </View>
      </View>
    )
  }

  return (
    <View style={{width: size, height: size}} pointerEvents="none">
      {/* @ts-ignore data is web-only — plain Lottie JSON object */}
      <DotLottieReact
        data={swipeUpForMoreData}
        autoplay
        loop
        style={{width: '100%', height: '100%'}}
      />
    </View>
  )
}
